import { Link } from "react-router-dom";
import cancel from "../../assets/images/icons/Cancel.svg";
import { useTranslation } from "react-i18next";

export const HeaderSearchPanel = ({
  query,
  setQuery,
  quickLinks,
  results,
  isLoading,
  autoFocus = false,
  onClose,
  onSelect,
}) => {
  const { t } = useTranslation("header");

  return (
    <>
      <div className="header__search-box">
        <input
          type="text"
          placeholder={t("search")}
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          autoFocus={autoFocus}
        />
        <button onClick={onClose}>
          <img src={cancel} alt="Cancel" />
        </button>
      </div>

      <div className="header__search-content">
        {query.length === 0 ? (
          <>
            <p>{t("quickLinks")}</p>
            <ul>
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} onClick={onSelect}>
                    <span>{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </>
        ) : (
          <>
            <p>{t("results")}</p>
            {isLoading ? (
              <p>{t("searching")}</p>
            ) : results.length > 0 ? (
              <ul>
                {results.map((result) => (
                  <li key={result.id}>
                    <Link to={result.path} onClick={onSelect}>
                      <span>{result.label}</span>
                      <small>{result.section}</small>
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              <p>{t("noResults")}</p>
            )}
          </>
        )}
      </div>
    </>
  );
};
